var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHangmanStages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__1",
    d: "M105 687 C92.298 687 82 697.298 82 710 L82 710 C82 722.702 92.298 733 105 733 L696 733 C708.702 733 719 722.702 719 710 L719 710 C719 697.298 708.702 687 696 687 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__2",
    d: "M128 119 C128 106.298 117.702 96 105 96 L105 96 C92.298 96 82 106.298 82 119 L82 710 C82 722.702 92.298 733 105 733 L105 733 C117.702 733 128 722.702 128 710 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__3",
    d: "M95.54 96 C88.062 96 82 106.298 82 119 L82 119 C82 131.702 88.062 142 95.54 142 L443.46 142 C450.938 142 457 131.702 457 119 L457 119 C457 106.298 450.938 96 443.46 96 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__4",
    d: "M92.425 176.705 C86.636 178.365 84.782 189.609 88.283 201.82 L88.283 201.82 C91.784 214.03 99.316 222.583 105.105 220.923 L374.449 143.69 C380.238 142.03 382.093 130.786 378.591 118.575 L378.591 118.575 C375.09 106.365 367.559 97.812 361.77 99.472 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__5",
    d: "M457 101.777 C457 98.586 446.702 96 434 96 L434 96 C421.298 96 411 98.586 411 101.777 L411 250.223 C411 253.414 421.298 256 434 256 L434 256 C446.702 256 457 253.414 457 250.223 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__6",
    d: "M510 256.5 C510 214.25 475.974 180 434 180 392.026 180 358 214.25 358 256.5 358 298.75 392.026 333 434 333 475.974 333 510 298.75 510 256.5 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__6 face",
    d: "M391.5 284 C387.91 284 385 286.91 385 290.5 L385 290.5 C385 294.09 387.91 297 391.5 297 L477.5 297 C481.09 297 484 294.09 484 290.5 L484 290.5 C484 286.91 481.09 284 477.5 284 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__6 face",
    d: "M414 238.5 C414 230.492 407.956 224 400.5 224 393.044 224 387 230.492 387 238.5 387 246.508 393.044 253 400.5 253 407.956 253 414 246.508 414 238.5 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__6 face",
    d: "M484 238.5 C484 230.492 477.956 224 470.5 224 463.044 224 457 230.492 457 238.5 457 246.508 463.044 253 470.5 253 477.956 253 484 246.508 484 238.5 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__7",
    d: "M447 318.019 C447 315.247 441.851 313 435.5 313 L435.5 313 C429.149 313 424 315.247 424 318.019 L424 446.981 C424 449.753 429.149 452 435.5 452 L435.5 452 C441.851 452 447 449.753 447 446.981 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__8",
    d: "M444.813 436.598 C444.003 433.948 438.422 433.304 432.348 435.161 L432.348 435.161 C426.275 437.018 422.008 440.672 422.818 443.323 L460.523 566.65 C461.333 569.301 466.914 569.944 472.988 568.088 L472.988 568.088 C479.062 566.231 483.328 562.576 482.518 559.926 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__9",
    d: "M386.215 559.798 C385.405 562.449 389.672 566.103 395.745 567.96 L395.745 567.96 C401.819 569.817 407.4 569.174 408.21 566.523 L445.915 443.196 C446.726 440.545 442.459 436.891 436.385 435.034 L436.385 435.034 C430.311 433.177 424.73 433.82 423.92 436.471 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__9",
    d: "M441.909 357.996 C440.128 355.873 434.739 357.461 429.874 361.544 L429.874 361.544 C425.009 365.626 422.509 370.657 424.29 372.781 L507.186 471.571 C508.967 473.695 514.356 472.106 519.221 468.024 L519.221 468.024 C524.087 463.942 526.587 458.911 524.805 456.787 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "stage stage__10",
    d: "M343.609 456.486 C341.827 458.61 344.327 463.641 349.192 467.723 L349.192 467.723 C354.057 471.806 359.446 473.394 361.228 471.271 L444.123 372.48 C445.905 370.356 443.405 365.325 438.539 361.243 L438.539 361.243 C433.674 357.16 428.286 355.572 426.504 357.696 Z",
    fill: "#1c1c1c",
    fillOpacity: 1,
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangmanStages);
export default __webpack_public_path__ + "static/media/hangman_stages.a0cb459db6b24e8a698f16013fdd40bd.svg";
export { ForwardRef as ReactComponent };